/* @flow */
'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _require = require('interface-datastore'),
    Adapter = _require.Adapter,
    Key = _require.Key,
    Errors = _require.Errors,
    _require$utils = _require.utils,
    filter = _require$utils.filter,
    take = _require$utils.take,
    sortAll = _require$utils.sortAll,
    replaceStartWith = _require$utils.replaceStartWith;

var Keytransform = require('./keytransform');
/**
 * A datastore that can combine multiple stores inside various
 * key prefixs.
 */


var MountDatastore = /*#__PURE__*/function (_Adapter) {
  _inherits(MountDatastore, _Adapter);

  var _super = _createSuper(MountDatastore);

  function MountDatastore(mounts) {
    var _this;

    _classCallCheck(this, MountDatastore);

    _this = _super.call(this);
    _this.mounts = mounts.slice();
    return _this;
  }

  _createClass(MountDatastore, [{
    key: "open",
    value: function open() {
      return Promise.all(this.mounts.map(function (m) {
        return m.datastore.open();
      }));
    }
    /**
     * Lookup the matching datastore for the given key.
     *
     * @private
     * @param {Key} key
     * @returns {{Datastore, Key, Key}}
     */

  }, {
    key: "_lookup",
    value: function _lookup(key) {
      var _iterator2 = _createForOfIteratorHelper(this.mounts),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var mount = _step2.value;

          if (mount.prefix.toString() === key.toString() || mount.prefix.isAncestorOf(key)) {
            var s = replaceStartWith(key.toString(), mount.prefix.toString());
            return {
              datastore: mount.datastore,
              mountpoint: mount.prefix,
              rest: new Key(s)
            };
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "put",
    value: function put(key, value, options) {
      var match = this._lookup(key);

      if (match == null) {
        throw Errors.dbWriteFailedError(new Error('No datastore mounted for this key'));
      }

      return match.datastore.put(match.rest, value, options);
    }
  }, {
    key: "get",
    value: function get(key, options) {
      var match = this._lookup(key);

      if (match == null) {
        throw Errors.notFoundError(new Error('No datastore mounted for this key'));
      }

      return match.datastore.get(match.rest, options);
    }
  }, {
    key: "has",
    value: function has(key, options) {
      var match = this._lookup(key);

      if (match == null) {
        return false;
      }

      return match.datastore.has(match.rest, options);
    }
  }, {
    key: "delete",
    value: function _delete(key, options) {
      var match = this._lookup(key);

      if (match == null) {
        throw Errors.dbDeleteFailedError(new Error('No datastore mounted for this key'));
      }

      return match.datastore.delete(match.rest, options);
    }
  }, {
    key: "close",
    value: function close() {
      return Promise.all(this.mounts.map(function (m) {
        return m.datastore.close();
      }));
    }
  }, {
    key: "batch",
    value: function batch() {
      var _this2 = this;

      var batchMounts = {};

      var lookup = function lookup(key) {
        var match = _this2._lookup(key);

        if (match == null) {
          throw new Error('No datastore mounted for this key');
        }

        var m = match.mountpoint.toString();

        if (batchMounts[m] == null) {
          batchMounts[m] = match.datastore.batch();
        }

        return {
          batch: batchMounts[m],
          rest: match.rest
        };
      };

      return {
        put: function put(key, value) {
          var match = lookup(key);
          match.batch.put(match.rest, value);
        },
        delete: function _delete(key) {
          var match = lookup(key);
          match.batch.delete(match.rest);
        },
        commit: function commit(options) {
          return Promise.all(Object.keys(batchMounts).map(function (p) {
            return batchMounts[p].commit(options);
          }));
        }
      };
    }
  }, {
    key: "query",
    value: function query(q, options) {
      var qs = this.mounts.map(function (m) {
        var ks = new Keytransform(m.datastore, {
          convert: function convert(key) {
            throw new Error('should never be called');
          },
          invert: function invert(key) {
            return m.prefix.child(key);
          }
        });
        var prefix;

        if (q.prefix != null) {
          prefix = replaceStartWith(q.prefix, m.prefix.toString());
        }

        return ks.query({
          prefix: prefix,
          filters: q.filters,
          keysOnly: q.keysOnly
        }, options);
      });

      var it = _many(qs);

      if (q.filters) q.filters.forEach(function (f) {
        it = filter(it, f);
      });
      if (q.orders) q.orders.forEach(function (o) {
        it = sortAll(it, o);
      });

      if (q.offset != null) {
        var i = 0;
        it = filter(it, function () {
          return i++ >= q.offset;
        });
      }

      if (q.limit != null) it = take(it, q.limit);
      return it;
    }
  }]);

  return MountDatastore;
}(Adapter);

function _many(iterable) {
  return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var i, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, v;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            i = 0;

          case 1:
            if (!(i < iterable.length)) {
              _context.next = 39;
              break;
            }

            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 4;
            _iterator = _asyncIterator(iterable[i]);

          case 6:
            _context.next = 8;
            return _awaitAsyncGenerator(_iterator.next());

          case 8:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 12;
            return _awaitAsyncGenerator(_step.value);

          case 12:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 20;
              break;
            }

            v = _value;
            _context.next = 17;
            return v;

          case 17:
            _iteratorNormalCompletion = true;
            _context.next = 6;
            break;

          case 20:
            _context.next = 26;
            break;

          case 22:
            _context.prev = 22;
            _context.t0 = _context["catch"](4);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 26:
            _context.prev = 26;
            _context.prev = 27;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 31;
              break;
            }

            _context.next = 31;
            return _awaitAsyncGenerator(_iterator.return());

          case 31:
            _context.prev = 31;

            if (!_didIteratorError) {
              _context.next = 34;
              break;
            }

            throw _iteratorError;

          case 34:
            return _context.finish(31);

          case 35:
            return _context.finish(26);

          case 36:
            i++;
            _context.next = 1;
            break;

          case 39:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 22, 26, 36], [27,, 31, 35]]);
  }))();
}

module.exports = MountDatastore;